module.exports = __webpack_public_path__ + "564f210a7fffe561e9ea54bc82311c8b.png";